import { render, staticRenderFns } from "./PRank.vue?vue&type=template&id=20d329c2&scoped=true"
import script from "./PRank.vue?vue&type=script&lang=js"
export * from "./PRank.vue?vue&type=script&lang=js"
import style0 from "./PRank.vue?vue&type=style&index=0&id=20d329c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d329c2",
  null
  
)

export default component.exports